import { Link } from '@routable/gross-ds';
import React from 'react';
import { PLATFORM_DISPLAY_SHORT_NAME } from 'constants/platform';
import helpDocs from 'helpers/helpDocs';
const LimitedToBaseCurrencyNotification = () => (React.createElement(React.Fragment, null,
    `If you have or will enable international payments within ${PLATFORM_DISPLAY_SHORT_NAME}, you will be limited to only domestic payments. `,
    React.createElement(Link, { href: helpDocs.SYNC_XB_PAYMENTS_TO_LEDGER, openInNewTab: true }, "Learn more")));
export default LimitedToBaseCurrencyNotification;
